export default __webpack_public_path__ + "static/media/a011-startup-2.b7e604f0.svg";